export const GET_TINYURL_REQUEST = "GET_TINYURL_REQUEST";
export const GET_TINYURL_SUCCESS = "GET_TINYURL_SUCCESS";
export const GET_TINYURL_ERROR = "GET_TINYURL_ERROR";
export const CLEAR_USE_TINYURL = "CLEAR_USE_TINYURL";
